module.exports = __webpack_public_path__ + "img/2.71b56d99.svg";